import { MODALS } from '@/guides/constants/modals.js';

const guideModals = {
    namespaced: true,
    state: {
        [MODALS.upsertCategory]: {
            visible: false,
            rendered: false,
            props: { categoryId: null },
        },
        [MODALS.deleteCategory]: {
            visible: false,
            rendered: false,
            props: { categoryId: null },
        },
    },
    mutations: {
        openModal (state, { modal, props = {} }) {
            if (!state[modal].rendered) state[modal].rendered = true;
            state[modal].visible = true;
            state[modal].props = props;
        },
        closeModal (state, { modal }) {
            if (state[modal].visible) {
                state[modal].visible = false;
            }
        },
    },
    actions: {
        openModal ({ commit }, { modal, props }) {
            commit('openModal', { modal, props });
        },
        closeModal ({ commit }, { modal }) {
            commit('closeModal', { modal });
        },
    },
    getters: {
        isModalOpen: (state) => (modal) => state[modal]?.visible,
    },
};

export default guideModals;
